import { FunctionComponent } from 'react'

import transfersCss from '../styles.module.scss'

const Block: FunctionComponent<{ width: string; height: number }> = ({
  width,
  height,
}) => <span className="placeholder d-block" style={{ width, height }} />

const TransfersSkeleton: FunctionComponent = () => (
  <div className="placeholder-glow" aria-hidden="true">
    <div className={transfersCss.statusGrid}>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className={`card ${transfersCss.skeletonCard}`}>
          <Block width="55%" height={12} />
          <Block width="70%" height={22} />
          <Block width="90%" height={10} />
        </div>
      ))}
    </div>

    <div className={`card ${transfersCss.panel}`}>
      <div className="card-head">
        <Block width="12rem" height={14} />
        <Block width="11rem" height={30} />
      </div>
      <div className={transfersCss.skeletonChart}>
        <Block width="100%" height={260} />
      </div>
    </div>

    <div className={transfersCss.metricsGrid}>
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className={`card ${transfersCss.skeletonCard}`}>
          <Block width="40%" height={12} />
          <Block width="30%" height={20} />
        </div>
      ))}
    </div>
  </div>
)

export default TransfersSkeleton
